module.exports = __webpack_public_path__ + "img/1up.90018bb1.png";